<template>
  <div
    class="t-Divider"
    :class="classes"
    :style="cssVars"
    data-testid="t-divider"
  />
</template>

<script>
export default {
  name: 'Divider',
  props: {
    spacing: { type: String, default: 'md' },
    vertical: { type: Boolean, default: false },
    height: { type: [Number, String], default: undefined },
    color: { type: String, default: 'var(--track-color-bluegray-20)' },
  },
  computed: {
    classes() {
      return {
        '-vertical': this.vertical,
      };
    },
    cssVars() {
      return {
        '--color': this.color,
        '--spacing': `var(--track-spacing-${this.spacing})`,
        '--height': this.height,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.t-Divider {
  --spacing: 0;
  border-color: var(--track-color-bluegray-20);
  border-style: solid;
  border-width: 0;

  border-bottom-width: 1px;
  height: 0;
  margin: var(--spacing) 0;
  width: 100%;

  &.-vertical {
    border-bottom-width: 0;
    border-left-width: 1px;
    height: var(--height, 100%);
    margin: 0 var(--spacing);
    width: 0;
  }
}
</style>
